import React from 'react';

interface JidraLogoProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  textColor?: string;
}

const JidraLogo: React.FC<JidraLogoProps> = ({
  width = 300,
  height = 180,
  style,
  textColor = '#344150',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 480 270"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    {/* Cable */}
    <path
      d="M10 180c60-60 120-20 200 30s140-80 260-20"
      stroke="#3898DB"
      strokeWidth="16"
      fill="none"
      strokeLinecap="round"
    />
    {/* Box */}
    <rect
      x="170"
      y="90"
      width="140"
      height="80"
      rx="4"
      fill="#2986BC"
      stroke="#215D7A"
      strokeWidth="4"
    />
    {/* Chip */}
    <rect x="205" y="50" width="70" height="50" rx="12" fill="#F4CA19" />
    <rect x="220" y="68" width="40" height="10" rx="2" fill="#E08A1D" />
    <rect x="220" y="84" width="40" height="10" rx="2" fill="#E08A1D" />
    {/* Box top flaps */}
    <polygon points="170,90 190,70 190,90" fill="#2986BC" stroke="#215D7A" strokeWidth="4" />
    <polygon points="310,90 290,70 290,90" fill="#2986BC" stroke="#215D7A" strokeWidth="4" />
    {/* JIDRA Text */}
    <text
      x="240"
      y="240"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="72"
      fill={textColor}
      fontWeight="bold"
    >
      JIDRA
    </text>
  </svg>
);

export default JidraLogo;
